import type { GetStaticProps } from 'next'
import ImageBanner from '@components/ImageBanner'
import type { pageTitle, pageContent } from '@lib/types'
import { CarouselBasic } from '@components/Carousels'
import { getPageTitleContentFromDB, getPageContentFromDB } from '@lib/pagequerys'
import { Container, Heading, Section, Text, List } from '@components/SectionComponents'

// Gets static props from DB
export const getStaticProps: GetStaticProps = async () => {

    // page_id in DB
    const pageIdDB: number = 30;

    // query DB for page title data
    const pageTitle: pageTitle = await getPageTitleContentFromDB(pageIdDB);

    // Array of pageContent - query DB for pageContent data
    const pageContent: pageContent[] = await getPageContentFromDB(pageIdDB);

    return {
        props: {
            pageTitle,
            pageContent
        }
    }
}

// Page takes a pageTitle, and pageContent array
export default function Page({ pageTitle, pageContent }: {
    pageTitle: pageTitle,
    pageContent: pageContent[],
}) {

    return (
        <>
            <ImageBanner title={pageTitle} subColor={"dark"} />

            {/* Section 0 */}
            <Section colour='brown'>
                <Container longer='bottom'>
                    <Heading h1={true} content={{
                        title: pageContent[0].title,
                        subtitle: pageContent[0].subtitle
                    }} />
                    <Text content={pageContent[0].text} />
                    <List content={pageContent[0].list} />
                </Container>
                <CarouselBasic images={pageContent[0].carouselImages} overlap='bottom' />
            </Section>

            {/* Section 2 */}
            <Section colour='cream'>
                <Container longer='both'>
                    <Heading h1={true} content={{
                        title: pageContent[2].title,
                        subtitle: pageContent[2].subtitle
                    }} />
                    <Text content={pageContent[2].text} />
                    <List content={pageContent[2].list} />
                </Container>
                <CarouselBasic images={pageContent[2].carouselImages} overlap='bottom' />
            </Section>

            {/* Section 1 */}
            <Section colour='white'>
                <Container longer='both'>
                    <Heading content={{ title: pageContent[1].title }} />
                    <List content={pageContent[1].list} underHeading={true} />
                </Container>
                <CarouselBasic images={pageContent[1].carouselImages} overlap='bottom' />
            </Section>

            {/* Section 3 */}
            <Section colour='cream'>
                <Container longer='both'>
                    <Heading content={{ title: pageContent[3].title }} />
                    <List content={pageContent[3].list} underHeading={true} />
                </Container>
                <CarouselBasic images={pageContent[3].carouselImages} />
            </Section>
        </>
    )
}

//Meta Data
Page.title = "Accessibility";
Page.description = "The Crocodile Hunter Lodge has worked hard to create accommodations to meet the needs of everyone"